module.exports = __webpack_public_path__ + "img/aimer.89f110ff.png";